<template>
    <div name="card" class="card" :style="background">
        <span class="gray-font">{{ number }}번째 불편함</span>
        <span class="contents-font" style="margin-top: 8px;">{{ info.contents }}</span>
        <div style="margin-top: 8px;" class="space-between">
            <span class="gray-font">1형당뇨 {{ info.yearCount }}년차</span>
            <div class="like-button" @click="onLike" :style="isLike ? 'background: var(--Blue-01_Primary-blue, #008DEF);' : 'background: var(--Gray-60, #6B7684)'">
                <img style="width: 12px; margin-right: 4px;" src="../../../assets/heart.png" />
                {{ info.likeCount }}
            </div>
        </div>
        
    </div>
</template>

<script>

export default {
    name: 'card',
    props: ['info', 'isLike', 'background', 'number'],
    methods: {
        onLike: function()
        {
            this.$emit('onLike');
        }
    }
}
</script>

<style scoped>
    .card {
        display: flex;
        padding: 16px;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        box-sizing: border-box;
        border-radius: 12px;
        background: var(--Gray-00, #FFF);
        width: 269px;
    }
    .space-between {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        height: 26px;
    }
    .like-button {
        display: flex;
        justify-content: center;
        align-items: center;    
        box-sizing: border-box;
        border-radius: 6px;
        background: var(--Gray-60, #6B7684);
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 128.571% */
        padding: 4px;
        cursor: pointer;
    }

    .gray-font {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
    .contents-font {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 20px; /* 125% */
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/pc_uncomfortable/Card.vue